import React, { Component } from 'react';
import { Big3DatePicker, NoResult, ComPhoto } from "../../../js/ComponentManager";
import { Big3Common } from '../../../js/IncludeManager'
import { format } from "date-fns";
/* 개발담당:양유빈
 * 화면기능:거래처 거래내역
 * 세부설명:
*/

export class DealHistory extends Component {
    static displayName = DealHistory.name;
    constructor(props) {
        super(props);
        this.Union_Uid = "";
        this.fromDate = format(Big3Common.Util.DateAdd(new Date(), -30), "yyyy-MM-dd");
        this.toDate = format(Big3Common.Util.DateAdd(new Date(), 1), "yyyy-MM-dd");      
        this.state = {
            FromDate: this.fromDate,
            ToDate: this.toDate,
            SelectMonth: 1,
            DealHistory:[]
        };
        this.handleCalendarChange = this.handleCalendarChange.bind(this);
        this.handleMonth_Click = this.handleMonth_Click.bind(this);
        this.handleSearch_Click = this.handleSearch_Click.bind(this);
    }
    //초기화
    async componentDidMount() {
        if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
            this.Union_Uid = this.props.ContentState.Union_Uid;
        }
        await this.CallRetailDealHistory()
    }    
    //거래내역 조회
    async CallRetailDealHistory() {
        try {
            
            Big3Common.Util.LoadingOn();
            if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
                const Model = {
                    FromDate: this.state.FromDate,
                    ToDate: this.state.ToDate,
                    Union_Uid: this.Union_Uid
                }
                let Data = await Big3Common.Post("api/Retail/MyRetail/GetRetailDealHistory",Model,true);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    let DealHistory = JSON.parse(Data.dataTable);
                    this.setState({ DealHistory: DealHistory });
                }
                else {
                    console.log(Data.message);
                }
            }
        }
        catch (e) {
            console.log("CallRetailInfoData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //월 버튼 클릭
    handleMonth_Click(event, Month) {
        let fromDate = format(Big3Common.Util.DateAdd(new Date(this.state.ToDate), -(Month * 30)), "yyyy-MM-dd");
        this.setState({ SelectMonth: Month, FromDate: fromDate });
        event.preventDefault();
    }
    //달력일자 변경
    handleCalendarChange(retunValue) {
        let TagId = retunValue.returnId;
        this.setState({ [TagId]: retunValue.SelectDate });
        return false;
    }
    //조회버튼 클릭
    handleSearch_Click(event) {
        this.CallRetailDealHistory();
        event.preventDefault();
    }
    //검색 UI
    Searchrender() {
        return (
            <div className="search_box">
                <div className="select_month_box">
                    <div className={this.state.SelectMonth === 1 ? "month select" : "month"} onClick={(e) => { this.handleMonth_Click(e, 1) }}>1개월</div>
                    <div className={this.state.SelectMonth === 3 ? "month select" : "month"} onClick={(e) => { this.handleMonth_Click(e, 3) }}>3개월</div>
                    <div className={this.state.SelectMonth === 6 ? "month select" : "month"} onClick={(e) => { this.handleMonth_Click(e, 6) }}>6개월</div>
                </div>
                <div className="select_date_box">
                    <div className="select_date_box_input">
                        <Big3DatePicker
                            className="form-control"
                            setDate={new Date(this.state.FromDate)}
                            DateChange={this.handleCalendarChange}
                            id="FromDate"
                        />
                    </div>
                    <div className="select_date_box_input">
                        <Big3DatePicker
                            className="form-control"
                            setDate={new Date(this.state.ToDate)}
                            DateChange={this.handleCalendarChange}
                            id="ToDate"
                        />
                    </div>
                    <button type="button" className="date_s_btn" onClick={this.handleSearch_Click}>조회</button>
                </div>
            </div>
        )
    }
    OrdMgtMstrender(DataList) {
        return (
            DataList.map(list =>
                <div className="alert_content" key={`${list.uid}${list.union_uid}${list.ordgrp_no}`}>
                    <div className="alert_img">
                        <ComPhoto
                            className="alert_img_in"
                            Photo={list.retail_photo}
                        />
                    </div>
                    <div className="alert_txt">
                        <div className="alert_title">{list.retail_area_nm === "" ? "" : `[${list.retail_area_nm}]`} {list.retail_org_name}</div>
                        <div className="product_name">주문 품목:  {list.goods_nms}</div>
                        <div className="product_name">주문 금액: {Big3Common.Util.Money(list.goods_price)}원</div>
                        <div className="product_name"> 결제: {list.pay_idx_nm}</div>
                        {list.ord_idx === "EX" ? <div className="excel_btn">엑셀주문장</div> : ""}
                    </div>
                </div>
            )
        )
    }    

    render() {
        const Searchrender = this.Searchrender();
        const DealHistory = this.state.DealHistory;
        const DealHistoryList = Big3Common.Util.groupBy(DealHistory, list => list.ord_dt);
        const DealHistoryJson = [];
        for (const item of DealHistoryList.entries()) {
            DealHistoryJson.push({
                "Ord_Dt": item[0],
                "DataList": item[1],
            });
        }

        return (
            <div className="container_box2 p_margin u_padding history_box2">
                {Searchrender}
                {
                    DealHistoryJson.map(list =>
                        <div key={list.Ord_Dt}>
                            <div className="date">{list.Ord_Dt}</div>
                            {this.OrdMgtMstrender(list.DataList)}
                        </div>
                    )
                }
                <NoResult
                    Visible={this.state.DealHistory.length === 0 ? true : false}
                    Top={"60%"}
                />
            </div>
        );
    }
}
